import { render, staticRenderFns } from "./printYZHTrans.vue?vue&type=template&id=1a6f81b6&scoped=true&"
import script from "./printYZHTrans.vue?vue&type=script&lang=js&"
export * from "./printYZHTrans.vue?vue&type=script&lang=js&"
import style0 from "./printYZHTrans.vue?vue&type=style&index=0&lang=less&"
import style1 from "./printYZHTrans.vue?vue&type=style&index=1&id=1a6f81b6&lang=less&scoped=true&media=print&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6f81b6",
  null
  
)

component.options.__file = "printYZHTrans.vue"
export default component.exports